import React, { useState } from 'react';
import { toastError, toastSuccess } from "../../../Utilities/toast";
import BaseHome from '../../Home/BaseHome';
import CreateScrimDetails from './CreateScrimDetails';
import CreateScrimRules from './CreateScrimRules';
import TabPanelSolid, { TabPanel } from '../../Common/TabPanelSolid';
import { t } from 'i18next';
import { useNavigate, useParams } from 'react-router';

const CreateScrim = () => {
    const { id } = useParams();

    const tabs = [t("private_contest.basic_details"), t("private_contest.game_rules")];
    const [value, setValue] = useState(0);
    const [scrimData, setScrimData] = useState(null);
    const [isScrimValid, setScrimValid] = useState(false);
    const [triggerValidation, setTriggerValidation] = useState(false);
    const navigate = useNavigate();

    const handleTabChange = (newValue) => {
        if (newValue === 1) {
            setTriggerValidation(true)
            return
        }
        if (newValue === 1 && (!scrimData || Object.keys(scrimData).length === 0)) {
            toastError('All fields are required!'); // Show toast message
            return;
        }
        setValue(newValue);
    };

    const getTabs = (val, index) => {
        return (
            <TabPanel className="scrim-body" value={val} index={index} keepMounted>
                <div className='scroll-none'>
                    {index === 0 ? (
                        <CreateScrimDetails id={id} setValue={setValue} setScrimData={setScrimData} setScrimValid={setScrimValid} triggerValidation={triggerValidation} setTriggerValidation={setTriggerValidation} />
                    ) : index === 1 ? (
                        <CreateScrimRules id={id} scrimData={scrimData} />
                    ) : null}
                </div>
            </TabPanel>
        );
    };

    return (
        <BaseHome title={id ?t("private_contest.edit_scrim"): t("private_contest.create_scrim")} onBackClick={() => {
            if(value===1){
                setValue(0)
                return
            }
            navigate(-1)
            localStorage.removeItem("scrimDetails");
            localStorage.removeItem("selectedGameType")
            localStorage.removeItem("rules");
        }}>
            <TabPanelSolid
                tabs={tabs}
                value={value}
                setValue={handleTabChange} // Use handleTabChange instead
                getTabs={getTabs}
            />
        </BaseHome>
    );
};

export default CreateScrim;
